import { useQuery } from "@tanstack/react-query"
import { ApplicationPropertyGet } from "../app/models/ApplicationProperty"
import { Guid } from "../app/models/CustomType"
import { digitalManagerApi } from "../services/api"

export function useApplicationProperties(
  applicationId?: Guid,
  onlyRequestable = false,
  getPossibleValues = false
) {
  const { data: applicationProperties = [], isLoading: isLoadingApplicationProperties } =
    useQuery({
      queryKey: [
        "applicationProperties",
        applicationId,
        onlyRequestable,
        getPossibleValues,
      ],
      queryFn: () =>
        digitalManagerApi
          .get<
            ApplicationPropertyGet[]
          >(`/applications/${applicationId}/properties`, { params: { onlyRequestable, getPossibleValues } })
          .then((r) => r.data),
      enabled: !!applicationId,
    })

  return {
    applicationProperties,
    isLoadingApplicationProperties,
  }
}
